/**
 * 设置统一资源数据
 * 
 * @param state 
 * @param resourceArray
 */
export const addDynamicRouter = (state: any, menuItems:any) => {
    if(menuItems && menuItems.length === 0){
        state.routerItems = []
    } else {
        state.routerItems = menuItems;
    }
    localStorage.setItem('dynRoutes', JSON.stringify(state.routerItems))
}

